"use strict";

// Check whether or not an element contains a class
var hasClass = function hasClass(element, className) {
  return " ".concat(element.className, " ").indexOf(" ".concat(className, " ")) > -1;
};